// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentPatientSearchRecordModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentPatientSearchRecordModel.attributeTypeMap;
    }
}
ExtEnrollmentPatientSearchRecordModel.discriminator = undefined;
ExtEnrollmentPatientSearchRecordModel.additionalProperties = false;
ExtEnrollmentPatientSearchRecordModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "cardStartDate",
        "baseName": "cardStartDate",
        "type": "Date"
    },
    {
        "name": "cardEndDate",
        "baseName": "cardEndDate",
        "type": "Date"
    },
    {
        "name": "cardActivationDate",
        "baseName": "cardActivationDate",
        "type": "Date"
    },
    {
        "name": "eligibilityStatusCode",
        "baseName": "eligibilityStatusCode",
        "type": "TCSEligibilityStatus"
    },
    {
        "name": "eligibilityStatusDescription",
        "baseName": "eligibilityStatusDescription",
        "type": "string"
    },
    {
        "name": "eligibilityDate",
        "baseName": "eligibilityDate",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "alternateCardIds",
        "baseName": "alternateCardIds",
        "type": ""
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
    {
        "name": "accumulators",
        "baseName": "accumulators",
        "type": ""
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "TCSCommunicationType"
    },
    {
        "name": "insuranceType",
        "baseName": "insuranceType",
        "type": "TCSInsuranceType"
    },
    {
        "name": "payerName",
        "baseName": "payerName",
        "type": "string"
    },
    {
        "name": "payerPhone",
        "baseName": "payerPhone",
        "type": "string"
    },
    {
        "name": "patientInsuranceBin",
        "baseName": "patientInsuranceBin",
        "type": "string"
    },
    {
        "name": "patientInsurancePcn",
        "baseName": "patientInsurancePcn",
        "type": "string"
    },
    {
        "name": "payerMedicalId",
        "baseName": "payerMedicalId",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentPatientSearchRecordModel.js.map